import type { TypeVideoConfig } from './types';

// ----------------------------------------------------------------------------

function mediaSource(video: HTMLVideoElement, config: TypeVideoConfig = {}): void {
    // If there is no element video
    if (!(video instanceof HTMLVideoElement)) {
        console.error('Is not an element video...');
        return;
    }

    // New Media Source
    const mediaSource = new MediaSource();
    const urlCreator = window.URL || (window as any).webkitURL;
    video.src = urlCreator.createObjectURL(mediaSource);

    // Function Source Open
    mediaSource.addEventListener('sourceopen', function (this: MediaSource): any {
        if (config.url == null) {
            return;
        }

        urlCreator.revokeObjectURL(video.src);

        // The encoding type of the media setting
        const mime = config.mime || 'video/webm; codecs="vp8, vorbis"';
        const sourceBuffer = this.addSourceBuffer(mime);

        // Fetch
        void fetch(config.url)
            .then(async function (response): Promise<any> {
                return response.arrayBuffer();
            })
            .then(function (arrayBuffer): any {
                const uint = new Uint8Array(arrayBuffer);

                // Create event (update end)
                sourceBuffer.addEventListener('updateend', function (): any {
                    if (!sourceBuffer.updating && mediaSource.readyState === 'open') {
                        mediaSource.endOfStream();

                        // After the data request is completed, we need to call endofstream(). It will change MediaSource.readyState  Is ended and the sourceended event is triggered.
                        video
                            .play()
                            .then(function (): any {
                                //
                            })
                            .catch(function (err): any {
                                console.log(err);
                            });
                    }
                });
                sourceBuffer.appendBuffer(uint);
            })
            .catch(function (err): any {
                console.log(err);
            });
    });
}

// ----------------------------------------------------------------------------

export { mediaSource };
